export default {
  // default
  default: '#b0b6c2',
  primary: '#53657d',
  secondary: '#d33b29',
  disabled: '#e4e5e4',

  // product
  paroRed: '#d33b29',
  paroSlategray: '#b0b6c2',
  paroDeepblue: '#53657d',
  paroRosegold: '#ebbfb0',
  paroEggshell: '#f5efee',

  textColor: '#333333',
  darkGray: '#9b9b9b',
  lightGray: '#e4e5e4',
  backgroundGray: '#f8f9fa',
  borderGray: '#e9ecef',
  paroBlack: '#333333',
  white: '#ffffff',
}
